import React from 'react';
import { SPALTEN } from './types';
import { Board } from './buildBoard';
import KanbanColumn from './KanbanColumn';
import { BoardActions } from './KanbanCard';

export default function KanbanBoard({ board, actions, busyId }: {
  board: Board; actions: BoardActions; busyId: number | null;
}) {
  return (
    <>
      {/* Desktop (md+): Spalten nebeneinander, horizontal scrollbar */}
      <div className='d-none d-md-flex flex-row gap-3 overflow-auto pb-3 align-items-start'>
        {SPALTEN.map((s) => (
          <div key={s.id} style={{ flex: '0 0 300px', minWidth: 300 }}>
            <KanbanColumn spalte={s} cards={board[s.id]} actions={actions} busyId={busyId} />
          </div>
        ))}
      </div>
      {/* Handy (xs/sm): Spalten VERTIKAL gestapelt */}
      <div className='d-md-none'>
        {SPALTEN.map((s) => (
          <div key={s.id} className='mb-3'>
            <KanbanColumn spalte={s} cards={board[s.id]} actions={actions} busyId={busyId} />
          </div>
        ))}
      </div>
    </>
  );
}
